module.exports = __webpack_public_path__ + "static/nntsugu-0e2f610b83948bf249ca54f795b3c767.jpg";